import { suggestedMerchantKnowledgeIdFormat } from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";

/** Leaves a tombstone the generator dedupes against, rather than deleting. */
export const rejectKnowledgeSuggestion = {
  name: "rejectKnowledgeSuggestion" as const,
  input: z.object({ id: suggestedMerchantKnowledgeIdFormat.schema }).strict(),
  output: z.null(),
};
